import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '@/app/store/auth'
import { vaultsApi } from './api'

// List vaults — used by forensics and other features
export function useVaults() {
    const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
    const mfaRequired = useAuthStore((state) => state.mfaRequired)

    return useQuery({
        queryKey: ['vaults'],
        queryFn: () => vaultsApi.list(),
        select: (response) => response.data,
        enabled: isAuthenticated && !mfaRequired,
    })
}
